import Image from "next/image";
import WhiteArrow from "@/app/assets/white-arrow-up.svg";
import PurpleArrow from "@/app/assets/purple-arrow-up.svg";

export default function ArrowButton({
  className,
  active,
  color,
}: {
  className?: any;
  active?: boolean;
  color?: string;
}) {

  return (
    <>
      {active ? (
        <div
          className={`${className ? className : ""
            } flex w-7 h-7 relative overflow-hidden`}
        >
          <Image
            src={color == "white" ? WhiteArrow : PurpleArrow}
            alt="mobile icon"
            width={20}
            height={20}
            className={`absolute w-full h-full top-0 bottom-0 left-0 right-0 `}
          />
        </div>
      ) : (
        <div
          className={`${className ? className : ""
            } flex w-7 h-7 relative group overflow-hidden`}
        >
          <Image
            src={color == "white" ? WhiteArrow : PurpleArrow}
            alt="mobile icon"
            width={20}
            height={20}
            className={`absolute w-full h-full top-0 bottom-0 left-0 right-0 group-hover:translate-x-[115%] group-hover:-translate-y-[115%] duration-300`}
          />
          <Image
            src={color == "white" ? WhiteArrow : PurpleArrow}
            alt="mobile icon"
            width={20}
            height={20}
            className={`absolute w-full h-full top-0 bottom-0 left-0 right-0 -translate-x-[115%] translate-y-[115%] group-hover:translate-x-0 group-hover:translate-y-0 duration-300`}
          />
        </div>
      )}
    </>
  );
}
